var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.formbuilder = {
	init: function () {
		$('.size_small').closest('.elm').addClass('size_small');

		const $form = $('form#moya_form_gjafabref');
		if ($form.length) {
			$('#fieldset_pagebreak2')
				.append('<div class="elm_total"><div class="label">Samtals Gleðikrónur</div><div class="value">0 kr.</div></div>')
				.append('<div class="elm_shipping hidden"><div class="label"></div><div class="value">0 kr.</div></div>');
			let $shipping = $('.elm_shipping');

			$('.elm_payment').each(function () {
				let price = $('input[name*="price"]', this).attr('value');
				let isShipping = $('input[name*="productID"]', this).attr('value') === 'Sending';
				if (isShipping) {
					$(this).addClass('shipping');
					$('.elm_shipping .label').text($('label.optional', this).text());
				}
				else {
					$(this).wrapInner('<div class="lmnt"/>');
				}
			});
			$('#submitForm').prop('disabled', 1);

			const $deliverFieldset = $('fieldset.hideBorder', $form);
			$deliverFieldset.addClass('hidden');

			$('.elm_radio input').change(function () {
				var $val = $(this).attr('id');
				if ($val.includes('vidtakanda')) {
					$deliverFieldset.removeClass('hidden');
				}
				else {
					$deliverFieldset.addClass('hidden');
				}
				$('.elm_payment.shipping input[type=number]').val($val.includes('sendingargjald') ? 1 : 0).trigger('change');
			});

			$('input[type=number]', '.elm_payment').on('change', function () {
				let total = 0;
				let shippingTotal = 0;
				$('.elm_payment').each(function () {
					let price = $('input[name*="price"]', this).attr('value');
					let isShipping = $('input[name*="productID"]', this).attr('value') === 'Sending';
					let quantity = $('input[type=number]', this).attr('value');
					if (isShipping) {
						shippingTotal += price * quantity;
					}
					else {
						total += price * quantity;
					}
				});
				$('.elm_total .value').text(Number(total).toLocaleString().replaceAll(',', '.') + ' kr.');
				$('.value', $shipping).text(Number(shippingTotal).toLocaleString().replaceAll(',', '.') + ' kr.');

				if (total > 0) {
					$('#submitForm').removeAttr('disabled');
				}
				else {
					$('#submitForm').prop('disabled', 1);
				}

				if (total > 0 && shippingTotal > 0) {
					$shipping.removeClass('hidden');
				}
				else {
					$shipping.addClass('hidden');
				}
			});
		}
	},
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};


site.frontpage = {
	init: function () {
		site.frontpage.scroll();
	},

	scroll: function () {
		$('span.scroll span', '.box.scroll').on('click', function () {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - offset,
				}, 1000);
				return false;
			}

		});
	},
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	},
});

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.formbuilder')) {
		site.formbuilder.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
